export default {
  controls: [],
  control: {},
  pagination: {},
  items: [],
  item: {},
  itemsPagination: {},
  groups: [],
  group: {},
  groupsPagination: {}
}
